<template>
    <div class="mt-2">
        <div class="small text-muted mb-1"><i class="far fa-barcode mr-1"></i>{{ component.name }}</div>
        <div class="input-group input-group-sm mb-1">
            <input ref="entry" type="text" class="form-control" :class="{'is-invalid': refused}" placeholder="Scanner ou saisir un N° de série" @keydown.enter.prevent="onEnter">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary" @click="add"><i class="fas fa-plus"></i></button>
            </div>
        </div>
        <div style="max-height: 120px; overflow-y: auto;">
            <div v-for="(sn, snIndex) in values" :key="sn" class="d-flex align-items-center justify-content-between py-1 px-2 mb-1" style="background: #f8f9fa; border-radius: 4px; font-size: 0.85rem;">
                <span><i class="far fa-barcode text-muted mr-1"></i>{{ sn }}</span>
                <button type="button" class="btn btn-sm text-danger p-0 ml-2" style="line-height: 1;" @click="$emit('remove', snIndex)"><i class="fas fa-times"></i></button>
            </div>
        </div>
        <small :class="values.length === expected ? 'text-success' : 'text-muted'">{{ values.length }} / {{ expected }}</small>
    </div>
</template>

<script>
    import $ from 'jquery'

    /** Les numéros d'un composant à numéros sur une ligne de kit du BL : kits × quantité par kit, choisis parmi ceux en stock. */
    export default {
        name: 'kit-serial-numbers-input',
        props: {
            component: Object,
            kits: [Number, String],
            values: Array,
            // Les numéros du composant déjà pris par une autre ligne du BL.
            taken: { type: Array, default: () => [] }
        },
        data() {
            return {
                refused: false
            };
        },
        computed: {
            expected: function () {
                var count = (parseFloat(this.kits) || 0) * (parseFloat(this.component.quantity) || 0);
                return Math.max(0, Math.floor(Math.round(count * 1e6) / 1e6));
            }
        },
        methods: {
            onEnter: function () {
                var instance = $(this.$refs.entry).autocomplete('instance');
                if (instance && instance.menu.active) return;
                this.add();
            },
            add: function () {
                var value = $(this.$refs.entry).val().trim();
                if (!value) return;

                if (this.values.length >= this.expected || this.values.includes(value) || this.taken.includes(value)) {
                    this.refused = true;
                    setTimeout(() => { this.refused = false; }, 1000);
                    return;
                }

                this.$emit('add', value);
                $(this.$refs.entry).val('').focus();
            }
        },
        mounted() {
            var vm = this;
            $(this.$refs.entry).autocomplete({
                minLength: 1,
                delay: 200,
                source: function (request, response) {
                    $.ajax({
                        url: '/api/articles/' + vm.component.article_id + '/serial-numbers',
                        data: { q: request.term },
                        dataType: 'json',
                        headers: vm.getHttpJsonRequestHeaders().headers,
                        success: function (data) {
                            response($.map(data, function (item) {
                                return vm.values.includes(item.serial_number) || vm.taken.includes(item.serial_number) ? null : { label: item.serial_number, value: item.serial_number };
                            }));
                        }
                    });
                },
                select: function (event, ui) {
                    $(vm.$refs.entry).val(ui.item.value);
                    vm.add();
                    return false;
                }
            });
        },
        beforeDestroy() {
            var $entry = $(this.$refs.entry);
            if ($entry.autocomplete('instance')) {
                $entry.autocomplete('destroy');
            }
        }
    }
</script>
